var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSketch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15l1.07 1.427-3.32 3.795-3.32-3.795L15 15h4.5zm.75-1.5h-6l-2.25 3 5.25 6 5.25-6-2.25-3z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21H6V3h6v4.5A1.504 1.504 0 0013.5 9H18v2.25h1.5V7.5a.68.68 0 00-.225-.525l-5.25-5.25A.682.682 0 0013.5 1.5H6A1.504 1.504 0 004.5 3v18A1.504 1.504 0 006 22.5h6V21zm1.5-17.7l4.2 4.2h-4.2V3.3z",
    fill: "#45464F"
  })));
}
export default SvgDocumentSketch;